import { render } from "./VevoDetail.vue?vue&type=template&id=7313654e&scoped=true&ts=true"
import script from "./VevoDetail.vue?vue&type=script&lang=ts"
export * from "./VevoDetail.vue?vue&type=script&lang=ts"

import "./VevoDetail.vue?vue&type=style&index=0&id=7313654e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7313654e"]])

export default __exports__